module.exports = __webpack_public_path__ + "static/media/370.2e247dcb.webp";